/* CCTV Center core. Small, deferred, no dependencies. */
(function () {
  'use strict';
  var CC = window.CC || (window.CC = {});
  var d = document, html = d.documentElement;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  CC.$ = $; CC.$$ = $$;

  /* ---------- money ---------- */
  CC.money = function (cents) {
    var n = Math.round((cents || 0) / 100);
    return (CC.prefix || 'Rs. ') + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  CC.waUrl = function (msg) { return 'https://wa.me/' + CC.wa + '?text=' + encodeURIComponent(msg || CC.waDefault || ''); };

  /* ---------- events ---------- */
  CC.emit = function (name, detail) { d.dispatchEvent(new CustomEvent(name, { detail: detail })); };
  CC.on = function (name, fn) { d.addEventListener(name, function (e) { fn(e.detail, e); }); };

  /* ---------- lazy modules ---------- */
  var loaded = {};
  CC.load = function (name) {
    if (loaded[name]) return loaded[name];
    loaded[name] = new Promise(function (res, rej) {
      var s = d.createElement('script'); s.src = CC.js[name]; s.defer = true;
      s.onload = function () { res(); }; s.onerror = rej; d.head.appendChild(s);
    });
    return loaded[name];
  };
  CC.idle = function (fn) { ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 1200); };
  CC.whenNear = function (el, fn, margin) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); fn(); } }, { rootMargin: margin || '300px 0px' });
    io.observe(el);
  };

  /* ---------- theme switch ---------- */
  function setTheme(t, store) {
    html.classList.add('c-swap');
    html.setAttribute('data-theme', t);
    if (store) { try { localStorage.setItem('cc-theme', t); } catch (e) {} html.removeAttribute('data-theme-auto'); }
    $$('[data-theme-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', t === 'dark'); b.setAttribute('aria-label', t === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'); });
    setTimeout(function () { html.classList.remove('c-swap'); }, 320);
    CC.emit('cc:theme', t);
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-theme-toggle]');
    if (b) setTheme(html.getAttribute('data-theme') === 'dark' ? 'light' : 'dark', true);
  });
  if (window.matchMedia) {
    var mq = matchMedia('(prefers-color-scheme: dark)');
    var follow = function (e) { if (html.hasAttribute('data-theme-auto')) setTheme(e.matches ? 'dark' : 'light', false); };
    mq.addEventListener ? mq.addEventListener('change', follow) : mq.addListener(follow);
  }
  $$('[data-theme-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', html.getAttribute('data-theme') === 'dark'); });

  /* ---------- open now (Pakistan time) ---------- */
  function pkNow() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: CC.tz || 'Asia/Karachi', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return { day: days[o.weekday], mins: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
    } catch (e) { var n = new Date(); return { day: n.getDay(), mins: n.getHours() * 60 + n.getMinutes() }; }
  }
  function parseHours(s) {
    var m = String(s || '').match(/(\d{1,2})[:.](\d{2})\s*-\s*(\d{1,2})[:.](\d{2})/);
    if (!m) return null;
    return [parseInt(m[1], 10) * 60 + parseInt(m[2], 10), parseInt(m[3], 10) * 60 + parseInt(m[4], 10)];
  }
  function fmt(mins) { var h = Math.floor(mins / 60), m = mins % 60, ap = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12; return h + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ' ' + ap; }
  CC.openState = function () {
    var now = pkNow(), today = parseHours((CC.hours || [])[now.day]);
    if (today && now.mins >= today[0] && now.mins < today[1]) return { open: true, label: 'Open now', sub: 'until ' + fmt(today[1]) };
    for (var i = 0; i < 8; i++) {
      var dd = (now.day + i) % 7, h = parseHours(CC.hours[dd]);
      if (!h) continue;
      if (i === 0 && now.mins < h[0]) return { open: false, label: 'Closed now', sub: 'opens ' + fmt(h[0]) };
      if (i > 0) return { open: false, label: 'Closed now', sub: 'opens ' + (i === 1 ? 'tomorrow ' : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dd] + ' ') + fmt(h[0]) };
    }
    return { open: false, label: 'Closed now', sub: '' };
  };
  function paintOpen() {
    var s = CC.openState(), today = pkNow().day;
    $$('[data-open-badge]').forEach(function (el) {
      el.classList.toggle('is-open', s.open); el.classList.toggle('is-closed', !s.open);
      var withSub = el.hasAttribute('data-sub');
      el.textContent = s.label + (withSub && s.sub ? ', ' + s.sub : '');
    });
    $$('[data-hours-day]').forEach(function (el) { el.classList.toggle('is-today', +el.getAttribute('data-hours-day') === today); });
  }
  CC.paintOpen = paintOpen;

  /* ---------- reveal + count-up ---------- */
  function reveal() {
    var els = $$('.c-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function countUp() {
    var els = $$('[data-count]:not([data-counted])');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; var el = en.target; io.unobserve(el); el.setAttribute('data-counted', '');
        var raw = el.textContent.trim(), m = raw.match(/^([^\d]*)([\d,.]+)(.*)$/);
        if (!m || reduce) return;
        var target = parseFloat(m[2].replace(/,/g, '')), dec = (m[2].split('.')[1] || '').length, t0 = null, dur = 1100;
        el.style.minWidth = el.offsetWidth + 'px';
        var step = function (ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur), e2 = 1 - Math.pow(1 - k, 3), v = (target * e2).toFixed(dec);
          if (!dec) v = String(Math.round(target * e2)).replace(/\B(?=(\d{3})+(?!\d))/g, m[2].indexOf(',') > -1 ? ',' : '');
          el.textContent = m[1] + v + m[3]; if (k < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      });
    }, { threshold: .6 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- scroll lock + drawers ---------- */
  var openStack = [];
  var scrim;
  function getScrim() {
    if (scrim) return scrim;
    scrim = d.createElement('div'); scrim.className = 'c-scrim'; scrim.hidden = true; d.body.appendChild(scrim);
    scrim.addEventListener('click', function () { CC.closeTop(); });
    return scrim;
  }
  CC.openDrawer = function (el, opener) {
    if (!el) return;
    if (openStack.indexOf(el) > -1) return;
    if (el.parentNode !== d.body) d.body.appendChild(el);
    var s = getScrim(); s.hidden = false; requestAnimationFrame(function () { s.classList.add('is-open'); });
    el.hidden = false; el.removeAttribute('inert');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    el._opener = opener || d.activeElement;
    openStack.push(el); d.body.classList.add('c-lock'); html.classList.add('c-drawer-open');
    setTimeout(function () { var f = el.querySelector('[autofocus],[data-focus-first]') || el.querySelector('button,a,input,select,textarea'); if (f) f.focus({ preventScroll: true }); }, 60);
    CC.emit('cc:drawer-open', el.id);
  };
  CC.closeDrawer = function (el) {
    if (!el) return;
    var i = openStack.indexOf(el); if (i < 0) return;
    openStack.splice(i, 1); el.classList.remove('is-open'); el.setAttribute('inert', '');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 320);
    if (!openStack.length) { scrim.classList.remove('is-open'); setTimeout(function () { if (!openStack.length) scrim.hidden = true; }, 260); d.body.classList.remove('c-lock'); html.classList.remove('c-drawer-open'); }
    if (el._opener && el._opener.focus) el._opener.focus({ preventScroll: true });
    CC.emit('cc:drawer-close', el.id);
  };
  CC.closeTop = function () { if (openStack.length) CC.closeDrawer(openStack[openStack.length - 1]); };
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') CC.closeTop();
    if (e.key === 'Tab' && openStack.length) {
      var el = openStack[openStack.length - 1], f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return; var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      var id = o.getAttribute('data-open');
      if (id === 'cart') { e.preventDefault(); CC.openCart(); return; }
      if (id === 'search') { e.preventDefault(); CC.load('search').then(function () { CC.openSearch && CC.openSearch(o); }); return; }
      if (id === 'quote') { e.preventDefault(); CC.openQuote(o); return; }
      var t = d.getElementById(id); if (t) { e.preventDefault(); CC.openDrawer(t, o); }
      return;
    }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); var dr = c.closest('[data-drawer]'); CC.closeDrawer(dr || openStack[openStack.length - 1]); }
  });

  /* ---------- toasts ---------- */
  CC.toast = function (msg, type) {
    var box = $('[data-toasts]'); if (!box) return;
    var t = d.createElement('div'); t.className = 'c-toast' + (type === 'error' ? ' c-toast--error' : ''); t.setAttribute('role', 'status');
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (type === 'error' ? '<circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16v.01"/>' : '<path d="m5 12.5 4.5 4.5L19 7.5"/>') + '</svg><span></span>';
    t.querySelector('span').textContent = msg; box.appendChild(t);
    setTimeout(function () { t.style.transition = 'opacity .3s'; t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 320); }, 2600);
  };

  /* ---------- cart ---------- */
  CC.cart = null;
  CC.fetchJSON = function (url, opts) {
    opts = opts || {}; opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opts.headers || {});
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || 'Request failed'); err.data = j; throw err; } return j; }); });
  };
  var queue = Promise.resolve();
  CC.queue = function (fn) { queue = queue.then(fn, fn); return queue; };
  CC.refreshCart = function () {
    return CC.fetchJSON(CC.routes.cartJs).then(function (c) { CC.cart = c; paintCount(c.item_count); CC.emit('cc:cart-updated', c); return c; });
  };
  function paintCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; el.classList.remove('c-bump'); void el.offsetWidth; el.classList.add('c-bump'); });
  }
  CC.addToCart = function (items, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    return CC.queue(function () {
      return CC.fetchJSON(CC.routes.add, { method: 'POST', body: JSON.stringify({ items: items }) })
        .then(function () { return CC.refreshCart(); })
        .then(function (c) {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); var lbl = btn.querySelector('[data-label]'); if (lbl) { var old = lbl.textContent; lbl.textContent = 'Added'; btn.classList.add('is-added'); setTimeout(function () { lbl.textContent = old; btn.classList.remove('is-added'); }, 1800); } }
          CC.emit('cc:header-show');
          CC.openCart();
          return c;
        })
        .catch(function (err) {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
          CC.toast(err.message || 'Could not add to cart. Please try again.', 'error');
        });
    });
  };
  CC.openCart = function () {
    if (CC.template === 'cart') { var m = $('#main'); if (m) m.scrollIntoView({ behavior: 'smooth' }); return; }
    CC.load('cart').then(function () { CC.cartDrawer && CC.cartDrawer.open(); }).catch(function () { location.href = CC.routes.cart; });
  };
  CC.openQuote = function (opener) {
    CC.load('quote').then(function () { CC.quote && CC.quote.open(opener); }).catch(function () { var u = opener && opener.getAttribute('href'); if (u) location.href = u; });
  };
  // product forms: [data-ajax-add] on forms (quick add, product page)
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ajax-add]'); if (!f) return;
    e.preventDefault();
    var fd = new FormData(f), id = fd.get('id'), q = parseInt(fd.get('quantity') || '1', 10);
    var btn = e.submitter && e.submitter.matches('[name=add],[data-add]') ? e.submitter : f.querySelector('[data-add]');
    if (e.submitter && e.submitter.hasAttribute('data-buy-now')) { location.href = '/cart/' + id + ':' + q; return; }
    var props = {}; fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    CC.addToCart([{ id: +id, quantity: q, properties: props }], btn);
  });

  /* ---------- product card variant chips ---------- */
  d.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-card-variant]'); if (!chip) return;
    e.preventDefault();
    var card = chip.closest('[data-card]'); if (!card) return;
    $$('[data-card-variant]', card).forEach(function (c) { c.setAttribute('aria-checked', c === chip); });
    var v = chip.dataset;
    var img = card.querySelector('[data-card-img]');
    if (img && v.img) { img.src = v.img; if (v.srcset) img.srcset = v.srcset; }
    var price = card.querySelector('[data-card-price]'); if (price) price.textContent = CC.money(+v.price);
    var cmp = card.querySelector('[data-card-compare]'); if (cmp) { cmp.textContent = +v.compare > +v.price ? CC.money(+v.compare) : ''; }
    var save = card.querySelector('[data-card-save]');
    if (save) { var s = (+v.compare || 0) - (+v.price || 0); save.hidden = s <= 0; if (s > 0) save.textContent = save.getAttribute('data-mode') === 'percent' ? Math.round(s / v.compare * 100) + '% off' : 'Save ' + CC.money(s); }
    $$('[data-card-link]', card).forEach(function (a) { a.href = v.url; });
    var input = card.querySelector('input[name=id]'); if (input) input.value = v.id;
    var wa = card.querySelector('[data-card-wa]'); if (wa && v.wa) wa.href = v.wa;
  });

  /* ---------- rails ---------- */
  function rails() {
    $$('[data-rail-wrap]').forEach(function (w) {
      if (w._rail) return; w._rail = 1;
      var r = w.querySelector('[data-rail]'), prev = w.querySelector('[data-rail-prev]'), next = w.querySelector('[data-rail-next]');
      if (!r || !prev || !next) return;
      var upd = function () { prev.disabled = r.scrollLeft < 8; next.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 8; };
      var by = function (dir) { var item = r.firstElementChild; var step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(r).columnGap || 16) : r.clientWidth * .8; r.scrollBy({ left: dir * step * Math.max(1, Math.floor(r.clientWidth / step)), behavior: 'smooth' }); };
      prev.addEventListener('click', function () { by(-1); }); next.addEventListener('click', function () { by(1); });
      r.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); upd();
    });
  }

  /* ---------- header: hide on scroll down, show on scroll up ---------- */
  function header() {
    var h = $('[data-header]'); if (!h) return;
    var last = window.scrollY, ticking = false, hidden = false, lockUntil = 0;
    var set = function (v) { if (v === hidden) return; hidden = v; h.classList.toggle('is-hidden', v); };
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY, dy = y - last;
        h.classList.toggle('is-scrolled', y > 8);
        if (Date.now() > lockUntil && !html.classList.contains('c-drawer-open')) {
          if (y < 120 || dy < -6) set(false); else if (dy > 6) set(true);
        }
        last = y; ticking = false;
      });
    }, { passive: true });
    CC.on('cc:header-show', function () { set(false); lockUntil = Date.now() + 1500; });
  }

  /* ---------- WhatsApp float peek ---------- */
  function waPeek() {
    var f = $('[data-wa-float]'); if (!f) return;
    var seen = false; try { seen = sessionStorage.getItem('cc-wa-peek'); } catch (e) {}
    if (seen) return;
    setTimeout(function () { f.classList.add('is-peek'); try { sessionStorage.setItem('cc-wa-peek', '1'); } catch (e) {} setTimeout(function () { f.classList.remove('is-peek'); }, 4200); }, 3500);
  }

  /* ---------- details accordions: one open at a time in a group ---------- */
  d.addEventListener('toggle', function (e) {
    var t = e.target; if (!t.matches || !t.matches('details[data-one]') || !t.open) return;
    var g = t.closest('[data-accordion]'); if (!g) return;
    $$('details[data-one]', g).forEach(function (o) { if (o !== t) o.open = false; });
  }, true);

  /* ---------- share ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-share]'); if (!b) return;
    e.preventDefault(); var url = b.getAttribute('data-url') || location.href, title = b.getAttribute('data-title') || d.title;
    if (navigator.share) navigator.share({ title: title, url: url }).catch(function () {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { CC.toast('Link copied'); });
  });

  /* ---------- init ---------- */
  CC.init = function (root) { reveal(); countUp(); rails(); paintOpen(); };
  function boot() {
    CC.init(); header(); waPeek();
    setInterval(paintOpen, 60000);
    CC.idle(function () { if (!CC.cart) CC.fetchJSON(CC.routes.cartJs).then(function (c) { CC.cart = c; paintCount(c.item_count); }).catch(function () {}); });
    if (window.Shopify && Shopify.designMode) {
      d.addEventListener('shopify:section:load', function () { CC.init(); });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
